// extracted by mini-css-extract-plugin
export default {"root":"root--J2Gm5"};